import { DateTime } from 'luxon';

import Validatable from '@/validator/Validatable';

export interface ILineItemMeasurementAPI {
  measurement_id: number;
  type: string;
}

export interface IMeasurementAPI {
  description: string;
  name: string;
  type: string;
  logo_url: string;
  measurement_id: number;
  created_on_utc?: string;
  modified_on_utc?: string;
  feature_key?: string;
}

export default class Measurement extends Validatable {
  constructor(
    public description: string,
    public name: string,
    public type: string,
    public logoURL: string,
    public measurementID: number,
    public createdOnUTC: DateTime,
    public modifiedOnUTC: DateTime,
    public featureKey?: string,
  ) {
    super();
  }

  static fromObject(obj: any) {
    return new Measurement(
      obj.description,
      obj.name,
      obj.type,
      obj.logoURL,
      obj.measurementID,
      obj.createdOnUTC,
      obj.modifiedOnUTC,
      obj.featureKey,
    );
  }

  static fromApi(apiObject: IMeasurementAPI): Measurement {
    return new Measurement(
      apiObject.description,
      apiObject.name,
      apiObject.type,
      apiObject.logo_url,
      apiObject.measurement_id,
      apiObject.created_on_utc ? DateTime.fromISO(apiObject.created_on_utc) : null,
      apiObject.modified_on_utc ? DateTime.fromISO(apiObject.modified_on_utc) : null,
      apiObject.feature_key,
    );
  }

  toApi() {
    return {
      description: this.description,
      name: this.name,
      type: this.type,
      logo_url: this.logoURL,
      measurement_id: this.measurementID,
      created_on_utc: this.createdOnUTC?.toISO(),
      modified_on_utc: this.modifiedOnUTC?.toISO(),
      feature_key: this.featureKey,
    };
  }
}
